module.exports = __webpack_public_path__ + "img/LinBie.cf9a98ab.jpg";